import React from "react";
import { getNameFromSignatureProperties } from "../../../../utils";
import { CryptoCertificateCard as Details } from "../../../common";
import { getRemainingCertificateValidTime } from "../../../utils";
import styles from "./cryptoAsset.module.scss";
const Summary = ({ certificate }) => {
    return (React.createElement("div", null,
        getNameFromSignatureProperties(certificate.subject),
        " ",
        React.createElement("small", { className: styles["secondary-text"] },
            "(Serial: ",
            React.createElement("code", null, certificate.serial_number),
            ")"),
        React.createElement("div", { className: styles["secondary-text"], title: certificate.valid_to },
            "Valid for: ",
            getRemainingCertificateValidTime(certificate.valid_to))));
};
export default { Details, Summary };
//# sourceMappingURL=Certificate.js.map